/* file description */
import React from 'react';
import RecordSelectLinkShowModalMemo from './../component/RecordSelectLinkShowModal';
import ReferenceRender from './../component/RecordSelectLinkShowModal/render';
import RecordTreeSelectMemo from './../component/RecordTreeSelect';
import CustomSelectMemo from './../component/CustomSelect';
import CustomSelectRender from './../component/CustomSelect/render';
import { TransformNalmalType2TableColumn } from './type';
import { COLUMN_FROM, VALUE_TYPES, SELECT_MODE } from './consts';
import _ from 'lodash';
import { Api as FetchAPI } from '@/utils';
import { Input } from 'antd';
import { getPlaceHolder } from '../../common/utils';

export const transformReference2TableColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  // FetchAPI,
  // isOpenGroup,
  isMobile,
  moduleInfo,
}) => {
  // console.groupCollapsed(`${field?.label}#${field?.name} transformReference2TableColumn`)
  // console.log('入参field', _.cloneDeep(field))
  // console.log('入参targetColumn', _.cloneDeep(targetColumn))
  const { dataKey, treeId, isModal, label, value, isLoad, isBindLabel, labelBindKey, isFieldFilter, parentField, labelBindLabel } = field?.bizConfig || {};

  const cloneField = _.cloneDeep(field);
  cloneField.options = field?.bizConfig;
  targetColumn.valueType = VALUE_TYPES.SELECT;

  // if (isOpenGroup && parentField && isFieldFilter) {
  // targetColumn.dependencies = [parentField];
  // }

  if (isModal || isLoad) {
    if (isModal) {
      // 超多数据那种, 需要弹窗展示那种，进行表单分页查询那种
      targetColumn.valueType = VALUE_TYPES.TEXT;
      targetColumn.renderFormItem = (_a, config, form) => {
        return (
          <RecordSelectLinkShowModalMemo
            value={config.value}
            storeValue={config.storeValue}
            form={form}
            config={config}
            field={cloneField}
            API={{ FetchAPI }}
            columnFrom={config.from}
            rowsData={config.formValue}
            isMobile={isMobile}
            moduleInfo={moduleInfo}
          />
        );
      };
    }
    if (isLoad) {
      targetColumn.renderFormItem = (_a, config, form) => {
        return <RecordTreeSelectMemo moduleInfo={moduleInfo} storeValue={config.storeValue} field={field} API={{ FetchAPI }} form={form} config={config} columnFrom={config.from} rowsData={config.formValue} isMobile={isMobile} />;
      };
    }
    // 只读态数据转为配置的显示值
    targetColumn.render = (dom, entity) => {
      const targerValue = entity?.value;
      const { setViewValue } = entity;
      return (
        <ReferenceRender setViewValue={setViewValue} field={cloneField} API={{ FetchAPI }} targerValue={targerValue} rowsData={entity.formValue} columnFrom={entity.from} />
      );
    };
    // console.log('处理后targetColumn', _.cloneDeep(targetColumn))
    // console.groupEnd()
    return targetColumn;
  }
  if (!dataKey || !treeId) {
    // console.error('缺少关联显示模型的namespID和moduleID配置！');
    // console.groupEnd()
    targetColumn.valueType = VALUE_TYPES.TEXT; // 否则会显示成为空的select http://uat.eimos.com/pro/lcp/task/TASK20221219105056929797/list?filterParams=%7B%7D 经营组织
    targetColumn.renderFormItem = targetColumn.renderFormItem || (() => {
      return <Input placeholder={getPlaceHolder(field.label)} />;
    });
    return targetColumn;
  }

  // 普通下拉
  targetColumn.renderFormItem = (_a, config, form) => {
    return <CustomSelectMemo moduleInfo={moduleInfo} storeValue={config.storeValue} form={form} config={config} field={cloneField} columnFrom={config.from} API={{ FetchAPI }} rowsData={config.formValue} isMobile={isMobile} />;
  };

  targetColumn.render = (dom, entity) => {
    const targerValue = entity?.value;
    const { setViewValue } = entity;
    return (
      <CustomSelectRender field={cloneField} API={{ FetchAPI }} targerValue={targerValue} setViewValue={setViewValue} />
    );
  };

  // console.log('处理后targetColumn', _.cloneDeep(targetColumn))
  // console.groupEnd()

  return targetColumn;
};
